import { t } from '@lingui/macro';

import { Button } from '@material-ui/core';
import AdminPage from '../AdminPage';
import DataTable from '../../data-table/DataTable';
import { useQueryLoader } from '../../data-table/Loaders';
import { useIntervalRefreshTrigger } from '../../data-table/Triggers';
import { Actions } from '../../page-framework';
import Link from '../../links/Link';
import { useColumnStyles } from '../agents/AgentStyles';
import { AdminPages, buildPageId, buildRootPageTarget } from '../AdminLinkUtils';
import {
    VOIP_AGENT_LIST_DATA_SOURCE,
    VOIP_AGENT_LIST_INITIAL_SORT,
    VOIP_AGENT_LIST_REFRESH_INTERVAL,
} from './VoipConstants';
import { getAgentListColumns } from './VoipAgentListHelper';

export default function VoipAgentListPage() {
    const classes = useColumnStyles();
    const loader = useQueryLoader(VOIP_AGENT_LIST_DATA_SOURCE, { disableFilterState: true });
    const { triggerRef } = useIntervalRefreshTrigger({ interval: VOIP_AGENT_LIST_REFRESH_INTERVAL });

    return (
        <AdminPage
            title={t`VoIP nPoints`}
            pageId={buildPageId(AdminPages.VoipConfig)}
            breadcrumbs={[
                { link: buildRootPageTarget(AdminPages.VoipConfig), text: t`VoIP Configuration` },
                { text: t`nPoint Configuration` },
            ]}
            actions={
                <Actions>
                    <Link to={`${buildRootPageTarget(AdminPages.VoipConfig)}/callManagers`}>
                        <Button>{t`CALL MANAGERS`}</Button>
                    </Link>
                </Actions>
            }
        >
            <DataTable
                tableId="voip-agent-list"
                loader={loader}
                triggerRef={triggerRef}
                columns={getAgentListColumns(classes)}
                visibleRows={0}
                disableColumnRemover
                sorters={VOIP_AGENT_LIST_INITIAL_SORT}
            />
        </AdminPage>
    );
}
